var $ = global.jQuery = global.$;
var widgets = require('../lib/widgets');
var utils = require('../lib/utils');

var ShowHide = require('./ShowHide');
var _Base = require('./_Base');

var Tabs = _Base.extend({
  init: function() {
    var self = this;

    this.classes = {
      open: 'is-active'
    };
    this.$tabs = this.$el.find('[data-tab]');
    this.tabs = widgets.add(this.$tabs, ShowHide);
    this.createTabs();

    $(window).on('resize orientationchange', this.resizeHandler.bind(this));
  },
  createTabs: function() {
    var self = this,
        startIndex = 0;

    this.$tabList = $('<div class="container"><nav class="tabs-nav tabs-nav--full"><ul role="tablist"></ul></nav></div>');

    this.tabToggles = [];

    $.each(this.tabs, function(index) {
      var text = this.$toggle.text();
      var $tab = $('<li class="tabs-nav__item" aria-controls="' + this.ids.content + '" aria-selected="false"><a href="#">' + text + '</a></li>');
      if (this.isOpen && !startIndex) startIndex = index;
      $tab.on('click', function(event) {
        event.preventDefault();
        self.openTab(index);
      });
      self.$tabList.find('ul').append($tab);
      self.tabToggles.push($tab);
    });

    this.openTab(startIndex, 0);
    this.$el.prepend(this.$tabList);
    this.tabsHidden = !this.$tabList.is(':visible');
    this.resizeHandler();
  },
  resizeHandler: function() {
    var startIndex = 0;
    if (this.tabsHidden && this.$tabList && this.$tabList.is(':visible')) {
      $.each(this.tabs, function(index) {
        if (this.isOpen && !startIndex) startIndex = index;
      });
      this.openTab(startIndex, 0);
    } else if (this.$tabList && !this.$tabList.is(':visible')) {
      $.each(this.tabs, function(index) {
        this.$content.css('opacity','1');
      });
    }
    this.tabsHidden = !this.$tabList.is(':visible');
  },
  openTab: function(index, duration) {
    var self = this;
    $.each(this.tabs, function(i) {
      if (i === index) {
        if (!this.isOpen) this.open('fadeIn', duration);
        self.tabToggles[i]
          .addClass(self.classes.open)
          .attr('aria-selected', true);
      } else {
        if (this.isOpen) this.close('fadeOut', 0);
        self.tabToggles[i]
          .removeClass(self.classes.open)
          .attr('aria-selected', false);
      }
    });
  }
});

module.exports = Tabs;



//////////////////
// WEBPACK FOOTER
// ./source/scripts/widgets/Tabs.js
// module id = 307
// module chunks = 0